import { DEFAULT_GROUPING } from '../../state';
export const onDeleteTrendCursor = (trendCursor) => ({
    type: 'DELETE_TREND_CURSOR',
    payload: {
        trendCursor,
    },
});
export const removeTrendCursorFromGroup = ({ trendCursor }, groups) => {
    var _a;
    const { id, group } = trendCursor;
    const currentGrouping = (_a = groups[group]) !== null && _a !== void 0 ? _a : DEFAULT_GROUPING;
    return {
        ...groups,
        [group]: {
            ...currentGrouping,
            trendCursors: currentGrouping.trendCursors.filter((trendCursorId) => trendCursorId !== id),
        },
    };
};
export const deleteTrendCursor = ({ trendCursor }, trendCursors) => {
    const { id: idToDelete } = trendCursor;
    return Object.entries(trendCursors).reduce((grouping, [nextTrendCursorId, value]) => {
        if (idToDelete === nextTrendCursorId)
            return grouping;
        grouping[nextTrendCursorId] = value;
        return grouping;
    }, {});
};
